import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=db37f2a8&scoped=true"
import script from "./sku.vue?vue&type=script&lang=js"
export * from "./sku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db37f2a8",
  null
  
)

export default component.exports